import { useContext, useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../redux/index';
import PageContext from "./PageContext";
import { HttpContext } from '../../api-services/HttpService';
import ApiRequestButton from './ApiRequestButton';
import applyFormat from '../functions/applyFormat'; 
import DynamicPageInput from "./DynamicPageInputCopy.jsx";
import dynamicValidation from "../functions/dynamicValidation";
import dynamicTransformation from "../functions/dynamicTransformation";
import validateInputArray from "../functions/validateInputArray";
import checkChange from "../functions/checkChange";
import CCOffcanvas from "./CCOffcanvas.tsx";
import ButtonComponent from "./ButtonComponent.jsx";

const EditCompanyDetailsModal = () =>{
    // get context variables from parent
    const { 
        editCompanyDetailsModal, 
        setEditCompanyDetailsModal,
        masterCompanyData, 
        getCompanyDetailsData,  
        snackbarAlert,
        processorDefaultData, 
        consortiumFlag, 
        masterCompanyLevelConfig, 
        masterCompanyLevelLists
    } = useContext(PageContext);
    // initialize http context 
    const {
        PUT, 
    } = useContext(HttpContext);
    // get persistant redux global state from store
    const company = useSelector((state) => state.company);
    const companyInfo = useSelector((state) => state.companyInfo); 
    // initialize reducers to update redux global state
    const dispatch = useDispatch();
    const { setCompany, setCompanyInfo } = bindActionCreators(actionCreators, dispatch);
    // initialize state
    const [values, setValues] = useState({}); 
    const [config, setConfig] = useState([]); 
    const [error, setError] = useState([{}]);

    // event handler for submit company details click
    const onSubmitClick = () =>{
        return new Promise((resolve, reject) => {
            // destructure values to pass by value
            let requestValues = [{...values}]; 
            // custom block on changing between consortium and non-consortium
            for (let i = 0; i < processorDefaultData.length; i++){
                if (requestValues[0]['incentiveid']['id'] == processorDefaultData[i]['id'] && consortiumFlag != processorDefaultData[i]['consortium']){
                    snackbarAlert(true, 'Please contact Argus Support to switch portfolio between Consortium and Non-Consortium.', 'error'); 
                    reject();
                    return; 
                }
            }
            // validate input
            let checkError = validateInputArray(
                requestValues, 
                masterCompanyLevelConfig,
                dynamicValidation,
                masterCompanyLevelLists, 
                snackbarAlert,  
                error, 
                setError, 
                (row, config, args) => {
                    let temp = row; 
                    // run dynamic transformation 
                    temp = dynamicTransformation(row, config, args); 
                    // remove all keys not in config
                    Object.keys(temp).map(key => {
                        let found = false; 
                        for (let i = 0; i < config.length; i++) {
                            if (config[i]['columnid'] == key){
                                found = true; 
                                break; 
                            }
                        }
                        // remove key if not found
                        if (!found) {
                            delete temp[key]; 
                        }
                    }); 
                    // return row on success
                    return temp; 
                }, 
                {},
            ); 
            // exit request if error 
            if (checkError) {
                reject(); 
                return; 
            }
            // get oldValues to attach to request 
            let temp = {...masterCompanyData}
            let oldValues = applyFormat(temp, masterCompanyLevelConfig, masterCompanyLevelLists, null); 
            oldValues = dynamicTransformation(oldValues, masterCompanyLevelConfig, {}); 

            // let response; 
            // // check to make sure inputs are valid
            // if (companyName == '' || rebateFrequency == null || portfolio == null ){
            //     snackbarAlert(true, 'Invalid input.', 'error');
            //     reject(); 
            //     return; 
            // };
            // // check to make sure primaryCCRM is in user list 
            // if (primaryCCRM != masterCompanyData['primaryccrm'] && 
            //     (!userList.includes(primaryCCRM) && primaryCCRM != '' && primaryCCRM != null)){
            //     snackbarAlert(true, 'Choose valid user for Primary CCRM ' + process.env.REACT_APP_CCRM_DESCRIPTION + '.', 'error'); 
            //     reject(); 
            //     return; 
            // }
            // // check that portfolio is no being changed between consortium and non consortium
            // for (let i = 0; i < processorDefaultData.length; i++){
            //     if (portfolio == processorDefaultData[i]['incentivetype'] && consortiumFlag != processorDefaultData[i]['consortium']){
            //         snackbarAlert(true, 'Please contact Argus Support to switch portfolio between Consortium and Non-Consortium.', 'error'); 
            //         reject();
            //         return; 
            //     }
            // }
            // // check that anniversary month is not null (and flag is true)
            // if (process.env.REACT_APP_ANNIVERSARY_MONTH == '1' && anniversaryMonth == null){
            //     snackbarAlert(true, 'Invalid anniversary month.', 'error'); 
            //     reject();
            //     return; 
            // }
            // // nullify primary ccrm if there is no change
            // let args = {}; 
            // if (primaryCCRM != masterCompanyData['primaryccrm'] && primaryCCRM != '' && primaryCCRM != null){
            //     args = {
            //         mastercompanyname: companyName, 
            //         mastercompanyid: masterCompanyData['mastercompanyid'], 
            //         incentivefreq: rebateFrequency,
            //         primaryccrm: primaryCCRM, 
            //         incentivetype: portfolio,  
            //         payoutmonth: anniversaryMonth, // column name in db is payoutmonth
            //     }
            // }
            // else if (primaryCCRM != masterCompanyData['primaryccrm'] && (primaryCCRM == '' || primaryCCRM == null)){
            //     args = {
            //         mastercompanyname: companyName, 
            //         mastercompanyid: masterCompanyData['mastercompanyid'], 
            //         incentivefreq: rebateFrequency,
            //         primaryccrm: 'None', 
            //         incentivetype: portfolio,  
            //         payoutmonth: anniversaryMonth, // column name in db is payoutmonth
            //     }
            // }
            // else {
            //     args = {
            //         mastercompanyname: companyName, 
            //         mastercompanyid: masterCompanyData['mastercompanyid'], 
            //         incentivefreq: rebateFrequency,
            //         incentivetype: portfolio,  
            //         payoutmonth: anniversaryMonth, // column name in db is payoutmonth
            //     }
            // }
            // // remove values that have not been changed from body of request
            // args = checkChange(initialValues, args); 
            // // add old values to arguments 
            // args['oldValues'] = initialValues.current; 

            console.log(requestValues); 
            // args for request 
            let args = {
                ...requestValues[0], 
                mastercompanyid: masterCompanyData['mastercompanyid'], 
                oldValues: oldValues
            }
            // make put request to update data in aurora db
            let response; 
            PUT('/client/companyDetailsData', args).then(res => {
                console.log(res);
                response = res; 
                // set company to new company name
                setCompany(requestValues[0]['mastercompanyname']);
                // hide modal on success
                setEditCompanyDetailsModal(editCompanyDetailsModal => editCompanyDetailsModal = false);
                // trigger success alert
                snackbarAlert(true, 'Successfully uploaded data.', 'success');
                // refresh CompanyDetailsPage using function from parent
                return getCompanyDetailsData(requestValues[0]['mastercompanyname']);
            }).then(res => {
                console.log(res);
                // resolve on success
                resolve(response); 
            }).catch(err => {
                console.log(err);
                // show alert on error
                snackbarAlert(true, 'Error uploading data.', 'error');
                // reject on error
                reject(err); 
            });
        }); 
    }

    // useEffect to run on config change 
    useEffect(() => {
        if (masterCompanyLevelConfig){
            setConfig(config => config = masterCompanyLevelConfig); 
        }
    }, [masterCompanyLevelConfig]); 

    // useEffect to run on masterCompanyData change
    useEffect(() => {
        if (masterCompanyData) {
            // add ids to lookup values 
            let temp = {
                ...masterCompanyData // destructure to pass by value 
            }; 
            temp = applyFormat(temp, masterCompanyLevelConfig, masterCompanyLevelLists, null); 
            // set state 
            setValues(values => values = temp); 
        }
    }, [masterCompanyData, masterCompanyLevelConfig, masterCompanyLevelLists]); 

    return( 
        <> 
            <CCOffcanvas
                title="Edit Company Details"
                show={editCompanyDetailsModal}
                onCanvasClose={()=>setEditCompanyDetailsModal(editCompanyDetailsModal => editCompanyDetailsModal = false)}
                bodyCssClassName="offcanvas-body bg-white p-3 pt-2"
                offCanvasClassName="offcanvas-parent-card-30"
                >
                <div className="d-flex flex-column h-100">
                    <div className="d-flex flex-column gap-3 flex-grow-1 overflow-scroll" >
                        {config.map((el) => 
                            <div>
                                <DynamicPageInput
                                    data={values}
                                    setData={setValues}
                                    config={el}
                                    args={masterCompanyLevelLists}
                                    width={'100%'}
                                    showError={error[0][el['columnid']]}
                                    topAlignTypography={true}
                                />
                            </div>
                        )}
                    </div>
                    {/* button to submit company details */}
                    <div
                        className="d-flex justify-content-end p-3 w-100 offcanvas-footer z-2" style={{height: '65px'}}
                    >
                        <ButtonComponent tag={"Cancel"} 
                            border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'} 
                            onButtonClick={()=>setEditCompanyDetailsModal(editCompanyDetailsModal => editCompanyDetailsModal = false)}
                        />
                        <ApiRequestButton onButtonClick={onSubmitClick} />
                    </div>
                </div>
            </CCOffcanvas>
        </>
    );
}

export default EditCompanyDetailsModal;